import {
  DensityMediumIcon,
  HelpIcon,
  Tooltip,
  Avatar,
  Popover,
  useStatefulRef,
  CloseIcon,
  Button,
} from "@forge/common";
import "./header.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPermissions } from "../../../../../store/action";
import AuthProvider from "../../../../../../common/authentication/authService";
import { AppState } from "../../../../../../common/store/combinedReducer";
import { useNavigate } from "react-router-dom";
import { btnResponsive } from "../../utils/helper";
import useResponsiveSize from "../../utils/useWindowSize";
import { hideModel, showModel } from "../../../store/model/model.action";
import aboutUs from "../../../../../../common/assets/IAS.jpg";
import { ABOUT_US } from "./constants";

interface HeaderProps {
  handleClickHam: () => void;
}

const Header: React.FC<HeaderProps> = ({ handleClickHam }) => {
  const anchor = useStatefulRef<HTMLDivElement>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpenHelpModal, setIsOpenHelpModal] = useState<boolean>(true);

  const userInfo = useSelector((state: any) => {
    return state.reducer.userInfo;
  });

  const csrf = useSelector((state: AppState) => {
    return state.reducer.csrf;
  });

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      const sub: any = AuthProvider().getUserId();
      if (sub) {
        if (!userInfo || !userInfo.hasOwnProperty("name")) {
          dispatch(
            getPermissions({
              userSub: sub,
              authorization: localStorage.getItem("access_token"),
            })
          );
        }
      } else if (csrf === false) {
        setTimeout(() => {
          localStorage.setItem("logged_out_from", "academy header 55");
          navigate("/");
        }, 500);
      }
    } else {
      setTimeout(() => {
        localStorage.setItem("logged_out_from", "academy header 62");

        navigate("/");
      }, 500);
    }
  }, []);

  const handlenavigateToHelp = () => {
    window.open(
      "/userAssistance/Content/Academy/Content/Resources/Station%20Help%20Landing%20Pages/Home%20for%20HA%20UG.htm",
      "_blank"
    );
  };

  const aboutUsPopup = () => {
    return (
      <div className="about-us-popup">
        <div className="flex justify-between">
          <p className="text-xl">{ABOUT_US.heading}</p>
          <CloseIcon
            id="aboutus-close-icon"
            data-testid="aboutus-close-icon"
            className="text-xl cursor-pointer"
            onClick={() => dispatch(hideModel())}
          />
        </div>
        <div>
          <div className="flex justify-between items-center">
            <div className="aboutus-content">
              <p>{ABOUT_US.version}</p>
              <div>
                <p>{ABOUT_US.pat}</p>
                <p className="mb-1">
                  Copyright {new Date().getFullYear()}, Honeywell International
                  Inc., All rights reserved
                </p>
                <div className="w-full flex justify-center">
                  <Button
                    id="end-user-button-id"
                    data-testid="end-user-button-id"
                    as="link"
                    href=""
                    className="end-user-button"
                    onClick={() => {
                      window.open(
                        "/licenseAgreement/license-agreement.htm",
                        "_blank",
                        "noopener noreferrer"
                      );
                    }}
                  >
                    End User License Agreement
                  </Button>
                </div>
              </div>
            </div>
            <img
              className="aboutus-img w-[150px] h-[100px] xl-high:w-[250px] xl-high:h-[200px] ml-2"
              src={aboutUs}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex gap-2 header mb-1">
      <DensityMediumIcon
        id="acc-header-id"
        data-testid="acc-header-id"
        className={`cursor-pointer hamburgerIcon ${btnResponsive(
          "panel-icons"
        )}`}
        onClick={handleClickHam}
      />
      <div className="flex space-x-2">
        <Tooltip content="Digital Prime Twin User Assistance" position="bottom">
          <HelpIcon
            id="help-icon-id"
            data-testid="help-icon-id"
            className={`cursor-pointer !text-[35px] xl-low!:text-[40px] xl-mid:!text-[40px] xl-high:!text-[45px]`}
            onClick={handlenavigateToHelp}
          />
        </Tooltip>
        <div ref={anchor} className="w-min" style={{ borderRadius: "100%" }}>
          <Avatar
            interactive
            size={useResponsiveSize() === "regular" ? "md" : "lg"}
            aria-label="profile"
            text={userInfo?.name ? userInfo.name.charAt(0).toUpperCase() : ""}
          />
          <Popover
            id="popover-t"
            position="top"
            anchor={anchor}
            attachEvent={true}
            anchorActiveClassName="active"
          >
            <div
              data-testid="profile-popover"
              className="h-auto dark:border-gray-410 dark:bg-container-dark popover-options"
            >
              <p data-testid="user-name" className="userData">
                {userInfo?.name}
              </p>
              <p
                id="about-us-link-id"
                data-testid="about-us-link"
                className="cursor-pointer text-white"
                onClick={() => {
                  dispatch(
                    showModel({
                      childTemplate: () => aboutUsPopup(),
                    })
                  );
                }}
              >
                About Us
              </p>
              <p
                id="logout-link"
                data-testid="logout-link"
                className="cursor-pointer text-white"
                onClick={() => {
                  localStorage.setItem("logged_out_from", "academy header");
                  navigate("/logout");
                }}
              >
                Log Out
              </p>
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};
export default Header;
